import { useOrganization } from '../contexts/OrganizationContext';

/**
 * The selected organization's ID for data requests. Empty while the URL requests
 * an organization the user can't access (`hasRequestedOrganizationAccessDenied`),
 * so pages skip their requests instead of loading another organization's data.
 */
export function useScopedOrganizationId(): string {
  const { selectedOrganization, hasRequestedOrganizationAccessDenied } = useOrganization();
  return hasRequestedOrganizationAccessDenied ? '' : selectedOrganization?.organizationId ?? '';
}
